import { useApprovalWorkflow } from 'app/domains/approval';
import { SidebarLoader } from 'app/domains/documents/SidebarLoader';
import { useEsigning } from 'app/domains/esigning/components/EsigningProvider';
import { useDocumentForEsigning } from 'app/domains/esigning/hooks/useDocumentForEsigning';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { ApprovalPendingState } from './ApprovalPendingState';
import { ApprovalRequestState } from './ApprovalRequestState';
import { CancellingState } from './CancellingState';
import { ConnectProviderState } from './ConnectProviderState';
import { CreatingState } from './CreatingState';
import { DocumentNotSupportedState } from './DocumentNotSupportedState';
import { FormState } from './FormState';
import { LoadingProviderErrorState } from './LoadingProviderErrorState';
import { PendingState } from './PendingState';
import { SignedState } from './SignedState';
import { useEsigningLoadingState } from './useEsigningLoadingState';
export const useComponent = () => {
    const { error: loadingConnectedProviderError, shouldConnectProvider } = useEsigningProviders();
    const { documentSupportsEsigning } = useDocumentForEsigning();
    const { signed, cancelling, creating, pending, submittingCancellation } = useEsigning();
    const { approvalLoading, approvalNotRequested, approvalPending } = useApprovalWorkflow();
    const loading = useEsigningLoadingState();
    if (loading || approvalLoading) {
        return <SidebarLoader />;
    }
    if (!documentSupportsEsigning) {
        return <DocumentNotSupportedState />;
    }
    if (signed) {
        return <SignedState />;
    }
    if (loadingConnectedProviderError) {
        return <LoadingProviderErrorState />;
    }
    if (shouldConnectProvider) {
        return <ConnectProviderState />;
    }
    if (cancelling) {
        return <CancellingState />;
    }
    if (submittingCancellation) {
        return <CancellingState polling={false}/>;
    }
    if (creating) {
        return <CreatingState />;
    }
    if (pending) {
        return <PendingState />;
    }
    if (approvalNotRequested) {
        return <ApprovalRequestState />;
    }
    if (approvalPending) {
        return <ApprovalPendingState />;
    }
    return <FormState />;
};
